<div>
    <mat-tab-group>
        <mat-tab *ngIf="entityNormative && entityNormative != ''" label="Norma entidad">
            <div class="normative-table-scroll">
                <div [innerHTML]="entityNormative"></div>
            </div>
        </mat-tab>
        <mat-tab *ngIf="planNormative  && planNormative != ''" label="Norma plan">
            <div class="normative-table-scroll">
                <div [innerHTML]="planNormative"></div>
            </div>
        </mat-tab>
        <mat-tab *ngIf="practiceNormative  && practiceNormative != ''" label="Norma prácticas">
            <div class="normative-table-scroll">
                <div [innerHTML]="practiceNormative"></div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>